"use client";

import { useEffect, useRef } from "react";

const MarketRecapView = ({ symbol }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    const script = document.createElement("script");
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js";
    script.async = true;

    script.innerHTML = JSON.stringify({
      symbol: symbol,
      colorTheme: "light",
      isTransparent: true,
      locale: "en",
      width: "100%", 
    });

    ref.current.innerHTML = "";
    ref.current.appendChild(script);
  }, [symbol]);

  return (
    <div className="tradingview-widget-container" style={{ width: "100%" }}>
      <div
        ref={ref}
        className="tradingview-widget-container__widget"
        style={{ width: "100%" }}
      />
    </div>
  );
};

export default MarketRecapView;